import { Typography } from '@material-ui/core';
import { useStyles } from './Statistics.styles';
import { StatisticsChipData } from './Statistics.types';

interface StatisticsChipProps {
  data: StatisticsChipData;
}

export const StatisticsChip: React.FC<StatisticsChipProps> = ({ data }) => {
  const classes = useStyles();

  return (
    <div className={classes.chip}>
      <div className={classes.valueField} style={{minWidth: data.value < 10000 ? 60 : 95}}>
          <Typography className={classes.value}>{data.value}</Typography>
      </div>
      <div className={classes.nameField} style={{padding: data.value < 10000 ? 20 : 10}}>
          <Typography  className={classes.name}>{data.name}</Typography>
      </div>
    </div>
  );
};
